import React from "react";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormContactSection from "../../components/contacts/FormContactSection";
import { useGetContactSection } from "../../hooks/contacts/useGetContactSection";
import { useUpdateContactSection } from "../../hooks/contacts/useUpdateContactSection";

const ContactSection = () => {
    const { contactSection, isLoading: isFetching } = useGetContactSection();
    const { mutate, isPending: isUpdating } = useUpdateContactSection();

    const handleSubmit = (data) => {
        mutate(data);
    };

    if (isFetching) {
        return null;
    }

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormContactSection
                currentData={contactSection}
                onSubmit={handleSubmit}
                isLoading={isUpdating}
            />
        </WrapperSection>
    );
};

export default ContactSection;
